import React from 'react';
import ChangePasswordContentPage from './components/change-password-content.page';

const ChangePasswordPage = () => {

  return (
    <ChangePasswordContentPage />
  );
};

export default ChangePasswordPage;
